import { Component, Input, OnInit } from '@angular/core';
import { SearchService, ConfigurationService, UtilsService } from '@un-fao/lightforms-lib/lightforms-services';

@Component({
    selector: 'latest-updates',
    templateUrl: './latest-updates.component.html',
    styleUrl: './latest-updates.component.css',
    standalone: false
})
export class LatestUpdatesComponent implements OnInit
{
  @Input() size: number = 3;
  @Input() resultsize: number = 12;
  @Input() sort: string = "document.references.reportingYear:DESC";

  public resources: Array<any>;
  public fisheries: Array<any>;

  constructor(
    private searchService: SearchService,
    public configService: ConfigurationService,
    public utilsService: UtilsService
  ) {}

  ngOnInit(): void 
  {
    let results: Array<any>;

    this.searchService.searchCollectionItems(
        this.configService.env.space, 
        'resource', 
        [],
        this.resultsize/2,0,this.sort,null,["id","document.title","document.references.reportingYear","document.objectSource.dataProvider","document.objectSource.coverPage.created","status","metadata"]).subscribe(res => 
    {
      this.resources = (res.results?.values || []).map(item => {
        return {
          title: item.document.title,
          category: item.document.references.reportingYear,
          link: this.configService.env.siteUrl + "/resource/" + item.id + "/" + this.configService.env.currentLang + "?status=" + item.status,
          date: item.document.references.reportingYear,
          description: '<div class="owner-container" title="' + item.document.objectSource.dataProvider.name + '"><img class="owner-logo" src="' + this.utilsService.processUrl(this.configService.env.space, item.document.objectSource.dataProvider.logo_url) + '" /></div>'
        }
      });
    });

    this.searchService.searchCollectionItems(
      this.configService.env.space, 
      'fishery', 
      [],
      this.resultsize/2,0,this.sort,null,["id","document.title","document.references.reportingYear","document.objectSource.dataProvider","document.objectSource.coverPage.created","status","metadata"]).subscribe(res => 
    {
      this.fisheries = (res.results?.values || []).map(item => {
        return {
          title: item.document.title,
          category: item.document.references.reportingYear,
          link: this.configService.env.siteUrl + "/fishery/" + item.id + "/" + this.configService.env.currentLang + "?status=" + item.status,
          date: item.document.references.reportingYear,
          description: '<div class="owner-container" title="' + item.document.objectSource.dataProvider.name + '"><img class="owner-logo" src="' + this.utilsService.processUrl(this.configService.env.space, item.document.objectSource.dataProvider.logo_url) + '" /></div>'
        }
      });
    });
  }
}